import styled from 'styled-components';

export const TroubleshootingBox = styled.section.attrs({
  className: 'space-y-3 rounded-md bg-vantis-silver px-3 pt-2 pb-3',
})``;

export const TroubleshootingHeading = styled.h4.attrs({
  className: 'text-xs font-semibold text-muted-foreground',
})``;

export const TroubleshootingList = styled.ol.attrs({
  className: 'space-y-3',
})``;

export const TroubleshootingItem = styled.li.attrs({
  className: 'flex gap-2',
})``;

export const TroubleshootingItemBody = styled.div.attrs({
  className: 'space-y-1',
})``;

export const TroubleshootingItemTitle = styled.h5.attrs({
  className: 'text-xs font-semibold leading-4',
})``;

export const TroubleshootingItemText = styled.p.attrs({
  className: 'text-xs text-muted-foreground',
})``;
